// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"13":"dd724c50","348":"b446fdd8","361":"a6109282","541":"6a662e33","723":"84ea4554","862":"cfacfc4f","961":"8ac48a14"}[chunkId] + ".chunk.js";
};